import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import MuiCardHeader from '@material-ui/core/CardHeader';
import styledBy from 'bento-ordering/base/utils/styleHelpers';

const styles = theme => ({
  title: {
    color: styledBy('disabled', {
      true: theme.palette.text.disabled
    })
  }
});

const CardHeader = ({ title, classes, disabled }) => {
  return (
    <MuiCardHeader
      disabled={disabled}
      disableTypography
      title={
        <Typography variant="h4" className={classes.title}>
          {title}
        </Typography>
      }
    />
  );
};

CardHeader.propTypes = {
  title: PropTypes.string.isRequired,
  classes: PropTypes.shape({}),
  disabled: PropTypes.bool
};

export default withStyles(styles)(CardHeader);
